import { Component, ElementRef, ViewChild } from '@angular/core';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { downloadFile } from '../../../lib/download-file';
import { loadScript } from '../../../lib/load-script';
import { sleep } from '../../../lib/sleep';
import { OnGetData } from '../../../services/dialog.service';
import { ButtonDirective } from '../../../shared/directives/button.directive';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    QRCode: any;
  }
}

@Component({
  selector: 'app-qr-code-dialog',
  templateUrl: './qr-code-dialog.component.html',
  styleUrls: ['./qr-code-dialog.component.scss'],
  standalone: true,
  imports: [ButtonDirective],
})
export class QrCodeDialogComponent implements OnGetData {
  dialogName = 'qr-code';
  close: (...args) => void;
  content: string;
  loading = true;
  @ViewChild('canvas') canvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasContainer') canvasContainer: ElementRef<HTMLDivElement>;
  dataUrl: string;

  dialogOptions(): DialogOptions {
    return { size: 560 };
  }

  async onGetData(data: { content: string }, close: (...args) => void) {
    this.close = close;

    await loadScript('https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js');
    await sleep(10);
    const div = document.createElement('div');
    new window.QRCode(div, {
      text: data.content,
      width: 256,
      height: 256,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: window.QRCode.CorrectLevel.H,
    });
    await sleep(100);
    this.dataUrl = div.querySelector('img').src;
    this.content = data.content;
  }

  downloadQrCode() {
    downloadFile(this.dataUrl, 'qr-code.jpg');
  }
}
